var map = {
	"./avatar.png": "4d41",
	"./businessManager.png": "4b99",
	"./designer.png": "90c8",
	"./developer.png": "37b9",
	"./master.png": "8999",
	"./other.png": "836b",
	"./productManager.png": "112e",
	"./testEngineer.png": "698a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";